export const en = {
        start: "Start",
        members: "Members",
        costs: "Costs",
        transactions: "Transactions",
        communication: "Communication",
        customerExperience: "Customer Experience",
        planDesign: "Plan Design",
        volumes: "Volumes",
        actives: "Actives",
        deferreds: "Deferreds",
        pensioners: "Pensioners",
        allMember: "All Members",
        voc: "VoC",
        sla: "SLA",
        digital: "Digital",
        dcAvc: "DC AVC",
        calls: "Calls",
        feedback: "Feedback",
        complaints: "Complaints",
        employers: "Employers",
        complexity: "Complexity",
        submit: "Submit",
        unlock: "Unlock",
        yourResults: "Results",
        membership: "Membership",
        

        naList: ["N/A", "NA", "nA", "Na", "na", "n/a", "N/a", "n/A", "n.a", "N.a", "n.A", "N.A", "n.a.", "N.a.", "n.A.", "N.A."], // first value will be used as default value
        unknownList: ["UNKNOWN", "Unknown", "unknown"],
        noTargetList: ["no target", "No target","NO TARGET"],
        //numberFormat: { Format: "(0,0)" },
        //integerFormat: { Format: "(0,0)" },
        //decimalFormat: { Format: "(0,0.00)" },
        //percentFormat: { Format: "(0.0)", Suffix: "%" },
        //moneyFormat: { Prefix: "$", Format: "(0,0.00)" },
        //thousandFormat: {  Format: "(0,0.0)" },// { Prefix: "$", Format: "(0,0 aK)" , Suffix: "K"},
        //millionFormat: { Prefix: "$", Format: "(0,0.0)", Suffix: "M" },//{ Prefix: "$", Format: "(0,0 aM)" },
        //billionFormat: { Prefix: "$", Format: "(0,0.0)", Suffix: "BN" },//{ Prefix: "$", Format: "(0,0 aB)" },
        //decimalSeparator: ".",
        //thousandDelimiter: ",",
        naNotAllowed: "N/A is not allowed",
        unknownNotAllowed:"Unknown is not allowed",
        addCommentsText: "add comment",
        dismissText: "dismiss",
        defaultText: "Used Imputed Cost",
        clickDismiss: "Click to dismiss",
        addExplanation: "Add explanation",
        invalidNumber: "Invalid number",
        singleError: "There is 1 problem highlighted in pink below that must be fixed before you can submit your data",
        singleWarning: "There is 1 unusual data item highlighted in yellow below that you should check. ",
        singleComment: "There is 1 unusual data item with provided comment. ",
        multipleErrors: "{0} problems highlighted in pink below that must be fixed before you can submit your data",
        multipleWarnings: "{0} unusual data items highlighted in yellow below that you should check. Point the cursor at each highlighted field to see specific error messages",//"{0} unusual data items to be checked.",
        multipleComments: "{0} unusual data items with comments provided. ",
        moreErrors: "{0} more errors",
        moreWarnings: "{0} more warnings",
        cleanSurveySubmitPage: "Your survey is clean! Please click submit.",
        singleErrorSubmitPage: "1 problem. It is highlighted in pink.",
        multipleErrorsSubmitPage: "The following tabs have problems that must be fixed before you can submit your data: {0}. The problems are highlighted in pink. Point the cursor at each highlighted field to see specific error messages. After fixing all the problems highlighted in pink (and after checking the unusual data items highlighted in yellow), please submit your survey by clicking the submit button below. ",//"{0} problems. They are highlighted in pink.",
        multipleWarningSubmitPage: "The following tabs have unusual data items: {0}.  The items are highlighted in yellow. Please check each items, and if possible, dismiss it or explain why the data is okay in the 'Add comment' field that appears when you point the cursor at the item. After checking all items, click submit below. ",
        thisTab: "This tab has ",
        yourComment: "Your comment: ",
        thisSurveyHas: "This survey has ",
        thisSurveyHasProblems: " This survey has {0} problems that must be fixed before it can be submitted: ",
        thisSurveyHasProblem: " This survey has 1 problem that must be fixed before it can be submitted: ",
        thisPageHasProblems: " This page has {0} problems that must be fixed before it can be submitted: ",
        thisPageHasProblem: " This page has 1 problem that must be fixed before it can be submitted: ",
        noErrorMsg: "There is no error message",
        errorMustBeFixed: "Errors that must be fixed before the survey can be submitted",
        expand: "Expand",
        collapse: "Collapse",
        rolesTable: [{ value: 'PabsStartUser', text: 'Start' }, { value: 'PabsMemberUser', text: 'Members' }, { value: 'PabsCostUser', text: 'Costs' }, { value: 'PabsTransactionUser', text: 'Transactions' }, { value: 'PabsCommunicationUser', text: 'Communication' }, { value: 'PabsCustomerExperienceUser', text: 'Customer Experience' }, { value: 'PabsPlanDesignUser', text: 'Plan Design' }],
        roles:['PabsStartUser', 'PabsMemberUser', 'PabsTransactionUser', 'PabsCommunicationUser', 'PabsCustomerExperienceUser', 'PabsPlanDesignUser'],
        currSurvey: 'Current survey',
        hisSurvey: 'Historic surveys (read only)',
        addPreparer: 'Additional Survey Preparers',
        pressButton: 'Press the add button above to give additional users permission to edit parts of the survey.',
        firstName:'First Name',
        lastName:'Last Name',
        email: 'Email',
        userAccess: 'User will have access to the following sections',
        note: 'Note: new user will be receiving an email with access instructions.',
        cemSurvey: 'CEM Surveys',
        addEdit: 'Add/Edit Survey Preparer',
        submitted:'Submitted'
    }
export default en;
    //window.Global = global;
